import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

import type { ITenant, IDefaultFilter } from '../tenants.types';

// -------------------------Tenant API Endpoints-------------------------
const URL_ROUTES = {
  list: 'tenant/list',
  add: 'tenant/add',
  update: 'tenant/update',
  details: 'tenant/details',
  delete: 'tenant/delete',
  limit: 'tenant/limit',
};
// ----------------------------------------------------------------------

const commonQueryParams = {
  headers: { 'Content-Type': 'application/json' },
  method: 'POST',
};

export const tenantApi = createApi({
  reducerPath: 'tenantApi',
  baseQuery,
  endpoints: (builder) => ({
    // Get Tenants List
    getTenantList: builder.mutation({
      query: (filterQuery: IDefaultFilter) => ({
        ...commonQueryParams,
        url: URL_ROUTES.list,
        body: filterQuery,
      }),
      transformResponse: (response: {
        data?: { tenant?: { list?: ITenant[]; total?: number } };
      }) => ({
        list: response?.data?.tenant?.list?.map((listItem) => ({ ...listItem })) ?? [],
        total: response?.data?.tenant?.total ?? 0,
      }),
    }),
    // Create Tenant
    createTenant: builder.mutation<ITenant, Partial<ITenant>>({
      query: (newTenant) => ({
        ...commonQueryParams,
        url: URL_ROUTES.add,
        body: newTenant,
      }),
      transformResponse: (response: { data?: { tenant: ITenant }; success: boolean }): ITenant =>
        response.success && response.data?.tenant ? response.data.tenant : ({} as ITenant),
    }),
    // Update Tenant Details
    updateTenant: builder.mutation<ITenant, { id: string; updates: Partial<ITenant> }>({
      query: ({ id, updates }) => ({
        ...commonQueryParams,
        url: URL_ROUTES.update,
        body: { id, ...updates },
      }),
    }),
    // Get Tenant Details
    getTenantDtl: builder.mutation({
      query: (id: string) => ({
        ...commonQueryParams,
        url: URL_ROUTES.details,
        body: { id },
      }),
    }),
    // Delete Tenants
    deleteTenants: builder.mutation({
      query: (ids: string[]) => ({
        ...commonQueryParams,
        url: URL_ROUTES.delete,
        body: { ids },
      }),
    }),

    updateLimit: builder.mutation({
      query: (upateData) => ({
        url: URL_ROUTES.limit,
        method: 'POST',
        body: upateData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useGetTenantListMutation,
  useCreateTenantMutation,
  useUpdateTenantMutation,
  useGetTenantDtlMutation,
  useDeleteTenantsMutation,
  useUpdateLimitMutation,
} = tenantApi;
